import React from 'react';
import {Text, View} from 'react-native';

function ReceptionCard() {
  return (
    <View className="BaseServiceCard">
      <Text>ServiceCard</Text>
    </View>
  );
}

export default ReceptionCard;
